import {
  listRequest,
  loginRequest,
  createUpdateAction,
  attendanceListRequest,
  updateRequest,
  attendanceLogListRequest,
  todayUsersListRequest,
} from "../../service/UserService";

/**
 * Login Action
 *
 * @param {*} data  JSON DATA TO SEND TO SERVER
 * @returns API RESULT
 */
export const loginAction = (requestData) => async (dispatch) => {
  const response = await dispatch(loginRequest(requestData));
  if (
    (response &&
      Object.keys(response).length &&
      response?.data?.status === 201) ||
    200
  ) {
    await localStorage.setItem("authToken", response.data.result.token);
    await localStorage.setItem("userId", response.data.result.id);
    await localStorage.setItem("userRoleId", response.data.result.role_id);
    await localStorage.setItem("userName", response.data.result.name);
    await localStorage.setItem("userEmail", response.data.result.email);
    await localStorage.setItem("userPhone", response.data.result.phone);
    await localStorage.setItem(
      "superuserId",
      response.data.result.super_user_id
    );
    await localStorage.setItem("orgId", response.data.result.orgId);

    return Promise.resolve(response.data);
  } else {
    return Promise.resolve(null);
  }
};
export const listAction = (data) => async (dispatch) => {
  const response = await dispatch(listRequest(data));

  if (
    (response &&
      Object.keys(response).length &&
      response?.data?.status == 201) ||
    200
  ) {
    return Promise.resolve(response.data);
  } else {
    return Promise.resolve(null);
  }
};

export const attendanceListAction = (data) => async (dispatch) => {
  const response = await dispatch(attendanceListRequest(data));

  if (
    (response &&
      Object.keys(response).length &&
      response?.data?.status == 201) ||
    200
  ) {
    return Promise.resolve(response.data);
  } else {
    return Promise.resolve(null);
  }
};

export const attendanceLogListAction = (data) => async (dispatch) => {
  const response = await dispatch(attendanceLogListRequest(data));

  if (
    (response &&
      Object.keys(response).length &&
      response?.data?.status == 201) ||
    200
  ) {
    return Promise.resolve(response.data);
  } else {
    return Promise.resolve(null);
  }
};

export const updateUserActon = (data) => async (dispatch) => {
  const response = await dispatch(updateRequest(data));

  if (
    (response &&
      Object.keys(response).length &&
      response?.data?.status == 201) ||
    200
  ) {
    return Promise.resolve(response.data);
  } else {
    return Promise.resolve(null);
  }
};

export const todayUsersListAction = (data) => async (dispatch) => {
  const response = await dispatch(todayUsersListRequest(data));

  if (
    (response &&
      Object.keys(response).length &&
      response?.data?.status == 201) ||
    200
  ) {
    return Promise.resolve(response.data);
  } else {
    return Promise.resolve(null);
  }
};
